/**
 * Created by mathias.gamperl on 17.06.2015.
 */
/**
 * Created by mathias.gamperl on 18.12.2014.
 */
export default ["$q", "Events", "$window", "$injector","$rootScope", "RequestService",function ($q, Events, $window, $injector, $rootScope, RequestService) {

  function getReqId(config) {
    return config.url + (config.params ? JSON.stringify(config.params) : "");
  }

  var requestInterceptor = {
    response: function (response) {
      //console.log("response: ", response);
      var id = getReqId(response.config);
      RequestService.remove(id, response.config);
      return response;
    },
    request: function (config) {
      //console.log("request: ", config);
      var id = getReqId(config);
      RequestService.add(id, config);
      return config;
    }

  };

  return requestInterceptor;
}];



// WEBPACK FOOTER //
// ./src/ui/app/interceptors/httpCanceler.js